import React, { useState, useEffect, useRef } from 'react';
import { FaTelegramPlane, FaShieldAlt, FaBell, FaRocket } from 'react-icons/fa';
import silhouette from '../../assets/img/elit.jpeg';
import './ComingSoon.css';

const TELEGRAM_BOT_URL = 'https://t.me/Keyiflifebot';

const PLACEHOLDER_PROFILES = [
    { id: 1, name: 'Yasemin', location: 'İstanbul', category: 'VIP'     },
    { id: 2, name: 'Defne',   location: 'Ankara',   category: 'Elite'   },
    { id: 3, name: 'Zeynep',  location: 'İzmir',    category: 'Premium' },
    { id: 4, name: 'Elif',    location: 'Antalya',  category: 'VIP'     },
    { id: 5, name: 'Selin',   location: 'Bursa',    category: 'Elite'   },
];

const T = {
    en: {
        register:        'Register',
        eyebrow:         'keyif.life',
        missionTag:      'We care about the person behind the profile',
        learnMore:       'Learn more',
        headline:        <>We have new standards.</>,
        heroSub:         <>Secure. Discreet. Automated.<br />Elevate your profile in the elite gallery.</>,
        freeAdText:      'Publish your ad for free before we go live.',
        countdown:       ['Days', 'Hours', 'Min', 'Sec'],
        registerBtn:     'Register via Telegram Bot',
        whyTelegramLink: 'Why Telegram?',
        galleryTitle:    'Elite Gallery',
        gallerySub:      'A curated showcase of verified profiles',
        stepsTitle:      'How it Works',
        stepsSub:        'Three steps to your elite listing',
        steps: [
            { num: '01', title: 'Connect',  desc: 'Tap the Telegram button to start our automated bot in seconds.' },
            { num: '02', title: 'Upload',   desc: 'Send your media and profile details directly through the chat.' },
            { num: '03', title: 'Go Live',  desc: 'Your profile is optimized and listed instantly in our elite gallery.' },
        ],
        trustTitle:      'Built for Privacy',
        trustSub:        "Everything you need. Nothing you don't.",
        trust: [
            { title: 'End-to-End Privacy',          desc: 'Your data never leaves our encrypted pipeline. Full discretion, always.' },
            { title: 'Real-time Lead Notifications', desc: 'Instant Telegram alerts the moment someone views or contacts you.' },
            { title: 'Zero-Friction Onboarding',    desc: 'No forms, no logins — everything handled through a single bot conversation.' },
        ],
        missionEyebrow:  'Our Mission',
        missionHeadline: <>We care about the person<br />behind the profile.</>,
        missionBody1:    'Every profile in our gallery belongs to a real person with real goals. We built keyif.life because we believe independent models and escorts deserve a platform that treats them with dignity — not as a commodity.',
        missionBody2:    'That means zero judgment, full discretion, and tools designed around your safety. No face-to-face meetings, no invasive verification, no public paper trail. Just a clean, professional presence that works for you while you focus on your work.',
        pillars: [
            { label: 'Dignity',   desc: 'We design every feature with respect for the people using it.' },
            { label: 'Safety',    desc: 'Your identity and location are never exposed without your consent.' },
            { label: 'Autonomy',  desc: 'You control your listing — activate, pause, or remove it anytime.' },
        ],
        whyTitle:        'Why Telegram?',
        whySub:          'We chose Telegram for a reason — actually, five of them.',
        why: [
            { num: '01', title: 'No App, No Registration',  desc: "You don't need to create an account or download anything new. If you have Telegram, you're already set up." },
            { num: '02', title: 'End-to-End Encrypted',     desc: "Your photos, details, and conversations never touch an unprotected server. Telegram's encryption keeps everything between you and us." },
            { num: '03', title: 'Instant Notifications',    desc: 'The moment a client views or contacts you, you get a real-time Telegram message — no email delays, no missed leads.' },
            { num: '04', title: 'Bot-Powered Automation',   desc: 'Our bot handles listing, updates, and renewals automatically inside the chat. No forms, no dashboards, no tech headaches.' },
            { num: '05', title: 'Anonymous by Default',     desc: 'You can operate under a username with no phone number exposed. Your real identity stays private at every step.' },
        ],
        footerCta:       'Ready to Go Live?',
        footer:          '© 2026 keyif.life — All rights reserved.',
    },
    tr: {
        register:        'Kayıt Ol',
        eyebrow:         'keyif.life',
        missionTag:      'Profil arkasındaki kişiyi önemsiyoruz',
        learnMore:       'Daha fazla',
        headline:        <>Yeni standartlarımız var.</>,
        heroSub:         <>Güvenli. Gizli. Otomatik.<br />Profilini seçkin galeride öne çıkar.</>,
        freeAdText:      'Yayına geçmeden önce ilanını ücretsiz yayınla.',
        countdown:       ['Gün', 'Saat', 'Dak', 'Sn'],
        registerBtn:     'Telegram Botu ile Kayıt Ol',
        whyTelegramLink: 'Neden Telegram?',
        galleryTitle:    'Seçkin Galeri',
        gallerySub:      'Doğrulanmış profillerin özenle seçilmiş vitrini',
        stepsTitle:      'Nasıl Çalışır?',
        stepsSub:        'Seçkin listeye üç adımda ulaş',
        steps: [
            { num: '01', title: 'Bağlan',      desc: 'Saniyeler içinde otomatik botumuzu başlatmak için Telegram butonuna dokun.' },
            { num: '02', title: 'Yükle',       desc: 'Medya dosyalarını ve profil bilgilerini doğrudan sohbet üzerinden gönder.' },
            { num: '03', title: 'Yayına Gir',  desc: 'Profilin optimize edilerek anında seçkin galerimizde listelenir.' },
        ],
        trustTitle:      'Gizlilik Önce Gelir',
        trustSub:        'İhtiyacın olan her şey. Fazlası yok.',
        trust: [
            { title: 'Uçtan Uca Gizlilik',          desc: 'Verileriniz şifreli altyapımızdan hiçbir zaman çıkmaz. Her zaman tam gizlilik.' },
            { title: 'Anlık Müşteri Bildirimleri',   desc: 'Biri seni görüntülediğinde veya iletişime geçtiğinde anında Telegram bildirimi alırsın.' },
            { title: 'Sıfır Sürtünmeli Başlangıç',  desc: 'Form yok, giriş yok — her şey tek bir bot sohbetiyle halledilir.' },
        ],
        missionEyebrow:  'Misyonumuz',
        missionHeadline: <>Profil arkasındaki kişiyi<br />önemsiyoruz.</>,
        missionBody1:    'Galerimizde yer alan her profil, gerçek hedefleri olan gerçek bir kişiye aittir. keyif.life\'ı, bağımsız modellerin ve escortların kendilerine saygıyla yaklaşan bir platforma hak kazandıklarına inandığımız için inşa ettik — bir meta gibi değil.',
        missionBody2:    'Bu, sıfır yargı, tam gizlilik ve güvenliğin etrafında tasarlanmış araçlar anlamına gelir. Yüz yüze görüşme yok, zorlayıcı doğrulama yok, kamuya açık iz yok. Sadece sen işine odaklanırken senin için çalışan temiz ve profesyonel bir varlık.',
        pillars: [
            { label: 'Saygı',      desc: 'Her özelliği kullanan kişilere saygıyla tasarlıyoruz.' },
            { label: 'Güvenlik',   desc: 'Kimliğin ve konumun, onayın olmadan hiçbir zaman ifşa edilmez.' },
            { label: 'Özgürlük',   desc: 'Listeni kendin yönetirsin — istediğin zaman aktif et, duraklat veya kaldır.' },
        ],
        whyTitle:        'Neden Telegram?',
        whySub:          'Telegram\'ı bir nedenden seçtik — aslında beş nedenden.',
        why: [
            { num: '01', title: 'Uygulama Yok, Kayıt Yok',   desc: "Hesap oluşturman veya yeni bir şey indirmen gerekmiyor. Telegram'ın varsa zaten hazırsın." },
            { num: '02', title: 'Uçtan Uca Şifreleme',        desc: "Fotoğrafların, bilgilerin ve sohbetlerin korumasız bir sunucuya hiç ulaşmaz. Telegram'ın şifrelemesi her şeyi aramızda tutar." },
            { num: '03', title: 'Anlık Bildirimler',           desc: 'Bir müşteri seni görüntülediğinde veya iletişime geçtiğinde anında Telegram mesajı alırsın — e-posta gecikmesi yok, kaçırılan fırsat yok.' },
            { num: '04', title: 'Bot Destekli Otomasyon',      desc: 'Botumuz listeleme, güncelleme ve yenilemeleri sohbet içinde otomatik olarak halleder. Form yok, panel yok, teknik baş ağrısı yok.' },
            { num: '05', title: 'Varsayılan Olarak Anonim',    desc: 'Telefon numarası ifşa edilmeden bir kullanıcı adıyla çalışabilirsin. Gerçek kimliğin her adımda gizli kalır.' },
        ],
        footerCta:       'Yayına Geçmeye Hazır mısın?',
        footer:          '© 2026 keyif.life — Tüm hakları saklıdır.',
    },
};

const TRUST_ICONS = [<FaShieldAlt />, <FaBell />, <FaRocket />];
const STEP_ICONS  = [<FaTelegramPlane />, <FaRocket />, <FaBell />];

const ComingSoon = () => {
    const launchDate = new Date('2026-04-11T00:00:00');

    const getTimeLeft = () => {
        const diff = launchDate - new Date();
        if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        return {
            days:    Math.floor(diff / (1000 * 60 * 60 * 24)),
            hours:   Math.floor((diff / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((diff / (1000 * 60)) % 60),
            seconds: Math.floor((diff / 1000) % 60),
        };
    };

    const [timeLeft, setTimeLeft]   = useState(getTimeLeft());
    const [lang, setLang]           = useState('tr');
    const [counts, setCounts]       = useState(null);
    const sliderRef  = useRef(null);
    const [sliderPos, setSliderPos] = useState(0);

    const t = T[lang];

    useEffect(() => {
        const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/profile-counts`)
            .then(res => res.json())
            .then(data => setCounts({ regular: data.regular, vip: data.vip }))
            .catch(() => setCounts({ regular: '—', vip: '—' }));
    }, []);

    useEffect(() => {
        const el = sliderRef.current;
        if (!el) return;
        const interval = setInterval(() => {
            setSliderPos(prev => {
                const maxScroll = el.scrollWidth - el.clientWidth;
                const next = prev + 1;
                if (next >= maxScroll) return 0;
                return next;
            });
        }, 20);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (sliderRef.current) sliderRef.current.scrollLeft = sliderPos;
    }, [sliderPos]);

    const countdownLabels = t.countdown;

    return (
        <div className="cs-page">
            {/* ── Nav ── */}
            <nav className="cs-nav">
                <span className="cs-nav-logo">keyif<span className="cs-nav-dot">.</span>life</span>
                <div className="cs-nav-right">
                    <div className="cs-lang-switch">
                        <button
                            className={`cs-lang-btn${lang === 'en' ? ' active' : ''}`}
                            onClick={() => setLang('en')}
                        >EN</button>
                        <span className="cs-lang-divider" />
                        <button
                            className={`cs-lang-btn${lang === 'tr' ? ' active' : ''}`}
                            onClick={() => setLang('tr')}
                        >TR</button>
                    </div>
                    <a
                        href={TELEGRAM_BOT_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cs-nav-cta"
                    >
                        <FaTelegramPlane />
                        <span>{t.register}</span>
                    </a>
                </div>
            </nav>

            {/* ── Hero ── */}
            <section className="cs-hero">
                <div className="cs-hero-bg-glow" />
                <div className="cs-hero-content">
                    <p className="cs-hero-eyebrow">{t.eyebrow}</p>

                    <div className="cs-mission-tag">
                        <span className="cs-mission-tag-text">{t.missionTag}</span>
                        <a href="#our-mission" className="cs-mission-tag-btn">{t.learnMore}</a>
                    </div>

                    <h1 className="cs-hero-headline">{t.headline}</h1>
                    <p className="cs-hero-sub">{t.heroSub}</p>

                    <p className="cs-free-ad-notice">{t.freeAdText}</p>

                    <div className="cs-countdown">
                        {[
                            { label: countdownLabels[0], value: timeLeft.days    },
                            { label: countdownLabels[1], value: timeLeft.hours   },
                            { label: countdownLabels[2], value: timeLeft.minutes },
                            { label: countdownLabels[3], value: timeLeft.seconds },
                        ].map(({ label, value }) => (
                            <div className="cs-countdown-item" key={label}>
                                <span className="cs-countdown-val">
                                    {String(value).padStart(2, '0')}
                                </span>
                                <span className="cs-countdown-label">{label}</span>
                            </div>
                        ))}
                    </div>

                    <div className="cs-cta-group">
                        <a
                            href={TELEGRAM_BOT_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cs-cta-btn"
                        >
                            <FaTelegramPlane className="cs-cta-icon" />
                            {t.registerBtn}
                        </a>
                        <a href="#why-telegram" className="cs-why-link">{t.whyTelegramLink}</a>
                    </div>

                    <div className="cs-profile-counts">
                        {counts ? (
                            <>
                                <div className="cs-count-item">
                                    <span className="cs-count-val">{counts.regular}</span>
                                    <span className="cs-count-label">
                                        {lang === 'tr' ? 'Standart Profil' : 'Regular Profiles'}
                                    </span>
                                </div>
                                <span className="cs-count-divider" />
                                <div className="cs-count-item">
                                    <span className="cs-count-val cs-count-val--vip">{counts.vip}</span>
                                    <span className="cs-count-label">
                                        {lang === 'tr' ? 'VIP Profil' : 'VIP Profiles'}
                                    </span>
                                </div>
                            </>
                        ) : (
                            <span className="cs-count-loading" />
                        )}
                    </div>
                </div>
            </section>

            {/* ── Profile Slider ── */}
            <section className="cs-slider-section">
                <h2 className="cs-section-title">{t.galleryTitle}</h2>
                <p className="cs-section-sub">{t.gallerySub}</p>
                <div className="cs-slider" ref={sliderRef}>
                    {PLACEHOLDER_PROFILES.map(profile => (
                        <div className="cs-card" key={profile.id}>
                            <div className="cs-card-img">
                                <img src={silhouette} alt="" className="cs-card-img-placeholder" />
                            </div>
                            <div className="cs-card-overlay">
                                <span className="cs-card-name">{profile.name}</span>
                                <span className="cs-card-meta">
                                    {profile.location} · {profile.category}
                                </span>
                            </div>
                            <span className="cs-card-badge">{profile.category}</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── How it Works ── */}
            <section className="cs-steps-section">
                <h2 className="cs-section-title">{t.stepsTitle}</h2>
                <p className="cs-section-sub">{t.stepsSub}</p>
                <div className="cs-steps">
                    {t.steps.map((step, i) => (
                        <div className="cs-step-card" key={step.num}>
                            <span className="cs-step-num">{step.num}</span>
                            <div className="cs-step-icon">{STEP_ICONS[i]}</div>
                            <h3 className="cs-step-title">{step.title}</h3>
                            <p className="cs-step-desc">{step.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── Trust / Privacy ── */}
            <section className="cs-trust-section">
                <h2 className="cs-section-title">{t.trustTitle}</h2>
                <p className="cs-section-sub">{t.trustSub}</p>
                <div className="cs-trust-grid">
                    {t.trust.map((item, i) => (
                        <div className="cs-trust-card" key={item.title}>
                            <div className="cs-trust-icon">{TRUST_ICONS[i]}</div>
                            <h3 className="cs-trust-title">{item.title}</h3>
                            <p className="cs-trust-desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── Our Mission ── */}
            <section className="cs-mission-section" id="our-mission">
                <div className="cs-mission-inner">
                    <div className="cs-mission-left">
                        <p className="cs-mission-eyebrow">{t.missionEyebrow}</p>
                        <h2 className="cs-mission-headline">{t.missionHeadline}</h2>
                    </div>
                    <div className="cs-mission-right">
                        <p className="cs-mission-body">{t.missionBody1}</p>
                        <p className="cs-mission-body">{t.missionBody2}</p>
                        <div className="cs-mission-pillars">
                            {t.pillars.map(p => (
                                <div className="cs-mission-pillar" key={p.label}>
                                    <span className="cs-mission-pillar-label">{p.label}</span>
                                    <span className="cs-mission-pillar-desc">{p.desc}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Why Telegram ── */}
            <section className="cs-why-section" id="why-telegram">
                <h2 className="cs-section-title">{t.whyTitle}</h2>
                <p className="cs-section-sub">{t.whySub}</p>
                <div className="cs-why-grid">
                    {t.why.map(item => (
                        <div className="cs-why-card" key={item.num}>
                            <span className="cs-why-num">{item.num}</span>
                            <h3 className="cs-why-title">{item.title}</h3>
                            <p className="cs-why-desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── Footer CTA ── */}
            <section className="cs-footer-cta">
                <h2 className="cs-footer-cta-headline">{t.footerCta}</h2>
                <a
                    href={TELEGRAM_BOT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cs-cta-btn"
                >
                    <FaTelegramPlane className="cs-cta-icon" />
                    {t.registerBtn}
                </a>
            </section>

            <footer className="cs-footer">
                <span>{t.footer}</span>
            </footer>
        </div>
    );
};

export default ComingSoon;
